<template>
  <section
    style="background-color: var(--page-background) !important"
    class="dashboard-view relative overflow-hidden"
    :class="{ mobile: getIsMobile, 'is-open': isCollapse }"
  >
    <div class="absolute -top-36 -left-36">
      <div
        style="background: var(--brand-500) !important"
        class="w-[345px] h-[284px] rounded-full blur-custom opacity-40"
      ></div>
    </div>
    <div class="absolute -right-36 -top-36">
      <div
        style="background: var(--brand-500) !important"
        class="w-[345px] h-[284px] rounded-full blur-custom opacity-40"
      ></div>
    </div>
    <div class="absolute -bottom-40 -right-40">
      <div
        style="background: var(--brand-500) !important"
        class="w-[345px] h-[284px] rounded-full blur-custom opacity-40"
      ></div>
    </div>
    <div class="absolute -bottom-44 -left-44">
      <div
        style="background: var(--brand-500) !important"
        class="w-[345px] h-[284px] rounded-full blur-custom opacity-40"
      ></div>
    </div>
    <el-row>
      <el-col :span="24">
        <ApplicationUserTopbar @open:sidebar="sidebarOpen"></ApplicationUserTopbar>
      </el-col>
    </el-row>
    <el-row type="flex" justify="center">
      <el-col :xl="24" :lg="24" :md="24">
        <div :class="!getIsOpen ? 'canvas' : 'offCanvas'" :style="computedCanvasStyle">
          <main
            style="background-color: #fff !important"
            class="main-dashboard-view !p-0 !mx-3 !bg-white h-[calc(100vh-63px)] !rounded-xl !border !border-page-border overflow-y-auto overflow-x-hidden"
            id="MainLayout"
          >
            <router-view :layout.sync="layout" />
          </main>
        </div>
      </el-col>
    </el-row>
    <div class="bg-canvas" v-on:click="closeLeftSideBar()"></div>
    <ApplicationUserSidebar :open="sidebarStatus" class="left-side-bar" />
    <keep-alive>
      <InternalChat v-if="getAuthenticatedUser && getStatusOfInternalChat && showChat" />
    </keep-alive>
  </section>
</template>
<script>
  import { postAPICall } from '@/helpers/httpHelper';
  import MobileRelatedHelper from '@/mixins/MobileRelatedHelper';
  import { mapGetters } from 'vuex';
  import InternalChat from '../../components/InternalChat.vue';
  export default {
    name: 'ApplicationUserDashboard',
    created() {
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
      if (this.getIsMobile) {
        this.$store.commit('navigationOpen/setIsOpen', false, {
          root: true,
        });
      }
    },
    mixins: [MobileRelatedHelper],
    computed: {
      ...mapGetters('auth', ['getAuthenticatedUser']),
      computedCanvasStyle() {
        if (this.getIsMobile) {
          return { marginLeft: '0' };
        } else if (this.getIsOpen) {
          return { marginLeft: '10rem' };
        } else {
          return { marginLeft: '3rem' };
        }
      },
      ...mapGetters('navigationOpen', ['getIsOpen', 'getIsCollapse', 'getIsMobile']),
      isCollapse: {
        get() {
          return this.getIsOpen;
        },
        set(isCollapse) {
          this.$store.commit('navigationOpen/setIsOpen', isCollapse, {
            root: true,
          });
        },
      },
      showChat() {
        return this.$route.matched.some((r) => r.meta.showChat);
      },
    },
    async mounted() {
      this.fetchBotInfo();

      // Fetch themes for application users when dashboard is mounted
      try {
        if (this.getAuthenticatedUser?.is_contact) {
          const companyId =
            this.getAuthenticatedUser?.company_id || this.getAuthenticatedUser?.account_data_id;
          if (companyId) {
            await this.$store.dispatch('theme/fetchThemes', companyId);
          }
        }
      } catch (themeError) {
        console.warn('Failed to fetch themes in dashboard:', themeError);
        // Don't fail the dashboard loading if theme fetching fails
      }
    },
    data() {
      return {
        getStatusOfInternalChat: false,
        layout: 'div',
        offCanvas: true,
        sidebarStatus: false,
        windowWidth: 1500,
      };
    },
    methods: {
      async fetchBotInfo() {
        this.loading = true;
        try {
          const response = await postAPICall('GET', '/bot/get-Bot');

          // Set internal chat status
          const enabled = !!response?.data?.internal_chat_enabled;
          this.getStatusOfInternalChat = enabled;
          localStorage.setItem('internal_chat_enabled', String(enabled));

          // Extract botId and token if chatBotDetails present
          const botAccounts = response?.data?.chatBotDetails || '';
          const botIdMatch = botAccounts.match(/botId: '(.*?)'/);
          const tokenMatch = botAccounts.match(/token: '(.*?)'/);

          if (botIdMatch && tokenMatch) {
            this.botId = botIdMatch[1];
            this.token = tokenMatch[1];
            localStorage.setItem('botId', this.botId);
            localStorage.setItem('token', this.token);

            if (this.botId && this.token) {
              window.bus.$emit('chatbot');
            } else {
              console.error('Failed to store botId or token in localStorage.');
            }
          }
        } catch (err) {
          console.warn('Failed to fetch bot info', err);
          this.getStatusOfInternalChat = false;
          localStorage.setItem('internal_chat_enabled', 'false');
        } finally {
          this.loading = false;
        }
      },

      sidebarOpen(status) {
        this.sidebarStatus = status;
      },
      closeLeftSideBar() {
        this.$store.commit('navigationOpen/setIsOpen', false, {
          root: true,
        });
      },
    },
    components: {
      InternalChat,
      ApplicationUserTopbar: () =>
        import('@/components/applicationUsers/applicationUsersTopbar.vue'),
      ApplicationUserSidebar: () =>
        import('@/components/applicationUsers/applicationUsersSidebar.vue'),
    },
  };
</script>

<style lang="scss">
  .dashboard-view {
    &.mobile {
      &.is-open {
        .bg-canvas {
          display: block;
        }
      }
      .main-dashboard-view {
        padding-left: 30px;
      }
      .left-side-bar {
        position: absolute;
        z-index: 11000;
      }
      .bg-canvas {
        background: rgba(0, 0, 0, 0.5);
        z-index: 10000;
        width: 100vw;
        height: 100vh;
        position: absolute;
        top: 0;
        left: 0;
        display: none;
      }
    }
  }

  .dashboard-view {
    min-height: 100vh;
    .main-dashboard-view {
      background: white !important;
      margin-top: 55px;
    }

    .edit-new-template-view {
      padding-left: 0;
    }

    .canvas {
      transition: all 0.2s ease-in-out;
    }

    .offCanvas {
      transition: all 0.2s ease-in-out;
    }
  }
</style>
